import type { FeedbackGrade } from '../types/FeedbackGrade'

export async function feedbackAsync(
  aidaLibrary: any,
  feedbackMessage: string,
  feedbackGrade: FeedbackGrade
): Promise<string | null> {
  return aidaLibrary
    .feedback(feedbackGrade, feedbackMessage)
    .then((answer: any) => {
      return answer
    })
    .catch((error: any) => {
      if (error.aida_error_id && error.aida_error_description) {
        let error_message = `${error.aida_error_id} ${error.aida_error_description}`
        console.error(error_message)
      } else {
        console.error(error)
      }
      return null
    })
}
